import React, { useEffect, useRef } from 'react';
import { Grid, Button, Avatar, Tab, alpha, Theme } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { RootState } from '@Common/models/redux/store';
import { useSelector } from 'react-redux';

const tabs = [
  {
    id: 'definition',
    name: 'Definition',
  },
  {
    id: 'importance',
    name: 'Importance',
  },
  {
    id: 'examples',
    name: 'Examples',
  },
  {
    id: 'benefits',
    name: 'Benefits',
  },
  {
    id: 'how',
    name: 'How To',
  },
  {
    id: 'plagiarism',
    name: 'Plagiarism',
  },
  {
    id: 'comparison',
    name: 'Comparison',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    // padding: '12px 0',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tabsRoot: {
    minHeight: 'auto',
  },
  tabsFixed: {
    position: 'sticky',
    top: 49,
    boxShadow: theme.shadows[3],
    zIndex: 10,
    [theme.breakpoints.down('sm')]: {
      top: 0,
    },
  },
  tabPill: {
    color: theme.specialColors.ICON_DEFAULT_COLOR,
    fontWeight: 600,
    opacity: 1,
    textTransform: 'none',
    fontSize: 16,
    lineHeight: '21.79px',
    minHeight: 'initial',
    padding: '15px 14px',
    backgroundColor: theme.specialColors.THREE_BEAM,
    // borderRadius: 100,
    // border: `1px solid ${fade(theme.palette.primary.main, 0.5)}`,
    borderBottom: '3px solid transparent',
    minWidth: 'initial',
    transition: 'all 0.1s ease-in-out',
    marginRight: 16,
    '&:last-child': {
      marginRight: 0,
    },
    '&:hover': {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 15,
      padding: '15px',
      marginRight: 8,
    },
  },
  tabSelected: {
    // color: theme.specialColors.THREE_BEAM,
    borderBottomColor: theme.palette.primary.main,
    color: `${theme.palette.primary.main} !important`,
    '&:hover': {
      color: `${theme.palette.primary.main} !important`,
    },
  },
  tabIndicator: {
    display: 'none',
  },
  tabFlexContainer: {
    maxWidth: '100%',
    overflowX: 'auto',
    padding: '0 16px',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    justifyContent: 'center',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      padding: '0 12px',
    },
    [theme.breakpoints.between(650, 900)]: {
      justifyContent: 'flex-start',
      padding: '0 12px',
      display: 'block',
    },
  },
}));

interface TabsProps {
  clickHandler: (event: React.MouseEvent<HTMLDivElement>, tab: string) => void;
  activeSection: string;
  tabsFixed: boolean;
}

function TabsNav(props: TabsProps) {
  const classes = useStyles();

  return (
    <div className={`${classes.root} ${props.tabsFixed && classes.tabsFixed}`}>
      <TabContext value={props.activeSection}>
        <TabList
          // onChange={handleChange}
          // variant="scrollable"
          // scrollableButtons="auto"
          classes={{
            root: classes.tabsRoot,
            indicator: classes.tabIndicator,
            flexContainer: classes.tabFlexContainer,
          }}
        >
          {tabs.map((tabItem) => (
            <Tab
              key={tabItem.id}
              label={tabItem.name}
              value={tabItem.id}
              onClick={(e) => props.clickHandler(e, tabItem.id)}
              classes={{
                root: classes.tabPill,
                selected: classes.tabSelected,
              }}
            />
          ))}
        </TabList>
      </TabContext>
    </div>
  );
}

export default TabsNav;
